import { APP_CONSTANTS, getCurrentUser } from './common/explicit-exports';
/**
 * Helper for determining the enterprise revenue_addon_enabled flag is enabled.
 * */
const isAddonEnabled = (name) => {
  const allowedAddons = APP_CONSTANTS.ENTERPRISE_ALLOWED_ADDONS;

  const user = typeof getCurrentUser === 'function' && getCurrentUser();
  if (!user?.enterprise) return false;

  if (!allowedAddons.includes(name)) return false;

  return user.enterprise[name];
};

export default isAddonEnabled;
